import { render } from "./viewer-modal.vue?vue&type=template&id=94f765d8&scoped=true"
import script from "./viewer-modal.vue?vue&type=script&lang=js"
export * from "./viewer-modal.vue?vue&type=script&lang=js"

import "./viewer-modal.vue?vue&type=style&index=0&id=94f765d8&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94f765d8"]])

export default __exports__